const { InnerBlocks, RichText } = wp.blockEditor

const Save = ({ attributes }) => {
  const { horizontal } = attributes

  return (
    <>
      <form className={`formCupom-${horizontal ? 'horizontal' : 'vertical'}`} id="formCupom">
        <InnerBlocks.Content />
        <div className="formCupom__field margin-section-small">
          <input
            id="field-name"
            title="name"
            type="text"
            autocomplete="off"
            required
            placeholder="Nome do Titular"
          />
          <span class="formCupom__field--validation">
            Informe um nome válido.
          </span>
        </div>
        <div className="formCupom__field margin-section-small">
          <input
            id="field-cpf"
            title="CPF"
            maxlength="14"
            type="text"
            autocomplete="off"
            required
            placeholder="CPF do Titular"
          />
          <span class="formCupom__field--validation">
            Informe um CPF válido.
          </span>
        </div>

        <button disabled class="Button btn-orange center-left submit-cupom">
          Gerar cupom
        </button>
      </form>
      <div className="modalCupom">
        <div className="modalCupom__wrapper">
          <a class="modalCupom__close">+</a>
          <p className="Typography title-6 center color-white"></p>
          <button class="Button btn-orange center copy-cupom">Copiar Cupom</button>
          <span className="Typography center color-white copySuccess">Cupom copiado para a área de transferência</span>
        </div>
      </div>
    </>
  )
}

export default Save
